module.exports = __webpack_public_path__ + "static/media/talentpools-menu.10327f65.png";